import styled from "styled-components";
import TopNavBarComponent from "../components/nav/TopNavBarComponent";
import { useParams } from "react-router-dom";
import { collection, getDocs, orderBy, query, where } from "firebase/firestore";
import { firestore } from "../../App";
import { useEffect, useState } from "react";
import { isSameStringDateYear, stringToDate } from "../../tools/DateTool";
import { Space } from "../components/Components";
import { formatFranc } from "../../tools/NumberTools";

const Container = styled.div`
	position: relative;
`;

const Content = styled.div`
	margin-top: 48px;
`;

const BookedList = styled.div`
	display: flex;
	flex-direction: column;
	gap: 6px;
`;

const ListHeader = styled.div`
	display: flex;
	padding: 6px 12px;
	border-radius: 3px;
	background: var(--color-surface-container-high);
	font-style: var(--md-sys-typescale-label-large-font-family-style);
	font-weight: var(--md-sys-typescale-label-large-font-weight);
	font-size: var(--md-sys-typescale-label-large-font-size);
	letter-spacing: var(--md-sys-typescale-label-large-tracking);
	line-height: var(--md-sys-typescale-label-large-height);
	text-transform: var(--md-sys-typescale-label-large-text-transform);
	text-decoration: var(--md-sys-typescale-label-large-text-decoration);
`;

const ListItem = styled.div``;

const ListItemHeader = styled.div`
	position: relative;
	display: flex;
	height: 56px;
	align-items: center;
	padding: 8px 16px;
	border-radius: 3px;
	gap: 16px;
	background: var(
		${(props) =>
			props.isOpen ? "--color-secondary-container" : "--color-surface"}
	);
	-webkit-user-select: none;
	user-select: none;
	transition: 0.3s;
	cursor: pointer;

	&:hover {
		background: var(--color-surface-container-highest);
	}

	.material-symbol:first-child {
		color: var(--color-secondary);
	}

	.material-symbol: last-child {
		transition: 0.3s;
		transform: ${(props) =>
			props.isOpen ? "rotate(180deg)" : "rotate(0deg)"};
	}

	div {
		display: flex;
		flex-direction: column;

		span {
			opacity: 0.75;
			font-style: var(--md-sys-typescale-label-medium-font-family-style);
			font-weight: var(--md-sys-typescale-label-medium-font-weight);
			font-size: var(--md-sys-typescale-label-medium-font-size);
			letter-spacing: var(--md-sys-typescale-label-medium-tracking);
			line-height: var(--md-sys-typescale-label-medium-height);
			text-transform: var(--md-sys-typescale-label-medium-text-transform);
			text-decoration: var(
				--md-sys-typescale-label-medium-text-decoration
			);
		}
	}
`;

const ListItemContent = styled.div`
	display: flex;
	flex-direction: column;
	max-height: ${(props) => (props.isOpen ? "400px" : "0px")};
	overflow: hidden;
	gap: 3px;
	padding: ${(props) => (props.isOpen ? "8px 16px" : "0px")};
	border-bottom: ${(props) =>
		props.isOpen ? "1px solid var(--color-outline)" : "none"};
	transition: 0.3s;
`;

export default function BookedPage() {
	const params = useParams();
	const [bookedEvents, setBookedEvents] = useState([]);
	const [openEvent, setOpenEvent] = useState(null);

	useEffect(() => {
		var allUsers = [];

		async function fetchUsers() {
			const userRef = collection(firestore, "users");
			const q = query(userRef);
			const docSnap = await getDocs(q);

			allUsers = docSnap.docs.map((doc) => {
				return { id: doc.id, name: doc.data().nome };
			});
		}

		async function fetchEvents() {
			const eventRef = collection(firestore, "events");
			let queryConstraints =
				params.userId === "0"
					? [
							where("uid", "!=", "I0yR09VGscWRA56pIa7jfIlRQsR2"),
							orderBy("timestampStartDate", "desc"),
					  ]
					: [
							where("uid", "==", params.userId),
							orderBy("timestampStartDate", "desc"),
					  ];

			const q = query(eventRef, ...queryConstraints);
			const docSnap = await getDocs(q);

			const events = docSnap.docs.map((doc) => {
				const bookerName =
					params.userId === "0"
						? (
								allUsers.find(
									(user) => user.id === doc.data().uid
								) || { name: "" }
						  ).name
						: "";
				console.log(allUsers, bookerName);

				return {
					id: doc.id,
					bookerName: bookerName,
					...doc.data(),
				};
			});
			setBookedEvents(events);
		}

		if (params.userId === "0") {
			fetchUsers();
		}
		fetchEvents();
	}, [params.userId]);

	return (
		<Container>
			<TopNavBarComponent
				title={"Prenotazioni"}
				centredTitle={true}
				goBack={true}
			/>
			<Content>
				<BookedList>
					{bookedEvents.map((event, index) => (
						<>
							{index === 0 ||
							!isSameStringDateYear(
								event.startDate,
								bookedEvents[index - 1].startDate
							) ? (
								<ListHeader key={`header-${index}`}>
									{stringToDate(
										event.startDate
									).getFullYear()}
								</ListHeader>
							) : null}
							<ListItem key={index}>
								<ListItemHeader
									isOpen={openEvent === index}
									onClick={() =>
										setOpenEvent(
											openEvent === index ? null : index
										)
									}
								>
									<span className="material-symbol fill">
										event
									</span>
									<div>
										{event.startDate} - {event.endDate}
										{params.userId === "0" && (
											<span>di {event.bookerName}</span>
										)}
									</div>
									<Space />
									<span className="material-symbol fill">
										arrow_drop_down
									</span>
								</ListItemHeader>
								<ListItemContent isOpen={openEvent === index}>
									<div>
										Scopo:{" "}
										{event.servicing
											? "Manutenzione/lavori"
											: "Personale"}
									</div>
									<div>
										CheckIn:{" "}
										{event.checkin ? "Fatto" : "Da fare"}
									</div>
									<div>
										CheckOut:{" "}
										{event.checkout ? "Fatto" : "Da fare"}
									</div>
									<div>
										Costo: {formatFranc(event.cost | 0)},{" "}
										{event.payed ? "Pagato" : "Non pagato"}
									</div>
								</ListItemContent>
							</ListItem>
						</>
					))}
				</BookedList>
			</Content>
		</Container>
	);
}
